import React from 'react';
import {
  ArticleContent,
  ArticleMainImage,
  ArticleTitle,
  ContentAndSidebar,
  MainCategory as MainCategoryComponent,
  PostMainContent,
  RecommendationsAdvertisement,
  ShareButton,
  Slideshow as SlideshowComponent,
  Sponsor,
} from 'mm-ui-components';
import { HeaderPostSidebarConnected } from '../../components/connectedComponents/PostSidebarConnected';
import { createDefaultBlocksWidths } from '../postPage.util';
import {
  ArticleComponentDataProps,
  FiniteScrollArticleComponentDataProps,
  MainArticleComponentDataProps,
} from '../utils/articleComponent.utils';
import { useFiniteScrollBrowserURLManagerRegistration } from '../../components/finiteScroll/FiniteScrollBrowserURLManager';

const defaultBlocksWidths = createDefaultBlocksWidths();

export const BaliArticleComponent: React.FunctionComponent<ArticleComponentDataProps> = props => {
  const {
    mainCategory,
    title,
    by,
    updatedText,
    createdAt,
    createdAtISO,
    updatedAt,
    updatedAtISO,
    showUpdatedAt,
    authors,
    shareConfig,
    cover,
    siteName,
    templateName,
    sponsor,
    slideshow,
    body,
    sideBar1Id,
    sideBar2Id,
    showRecommendationsAdvertisement,
    revcontentWidgetID,
    sideBar1AdOnSuccess,
    sideBar2AdOnSuccess,
    mainArticleURL,
  } = props;
  const { canonical } = props as MainArticleComponentDataProps;
  const { articleUrl } = props as FiniteScrollArticleComponentDataProps;
  const url = mainArticleURL || canonical || articleUrl;
  const ref = useFiniteScrollBrowserURLManagerRegistration(url as string);

  return (
    <div ref={ref}>
      <ContentAndSidebar>
        <PostMainContent>
          <header>
            {mainCategory ? (
              <MainCategoryComponent
                {...mainCategory}
                marginFactor={{
                largeMarginFactor: 0,
                mediumMarginFactor: 0,
                smallMarginFactor: 1,
              }}
              />
          ) : null}
            <ArticleTitle
              title={title}
              by={by}
              updatedText={updatedText}
              createdAt={createdAt}
              createdAtISO={createdAtISO}
              updatedAt={updatedAt}
              updatedAtISO={updatedAtISO}
              showUpdatedAt={showUpdatedAt}
              authors={authors}
            >
              <ShareButton shareConfig={shareConfig} canonical={url} />
            </ArticleTitle>
            <ArticleMainImage
              {...cover}
              siteName={siteName}
              templateName={templateName}
              defaultBlocksWidths={defaultBlocksWidths}
            />
          </header>
          {sponsor ? <Sponsor {...sponsor} /> : null}
          <SlideshowComponent {...slideshow} blockWidths={defaultBlocksWidths}>
            <ArticleContent
              body={body}
              templateName={templateName}
              siteName={siteName}
              defaultBlocksWidths={defaultBlocksWidths}
            />
          </SlideshowComponent>
        </PostMainContent>
        <HeaderPostSidebarConnected adId1={sideBar1Id} adId2={sideBar2Id} adOnSuccess2={sideBar2AdOnSuccess} adOnSuccess1={sideBar1AdOnSuccess} />
        {showRecommendationsAdvertisement
        ? <RecommendationsAdvertisement revcontentWidgetID={revcontentWidgetID} /> : null}
      </ContentAndSidebar>
    </div>
  );
};
